export const makeSpeseAccessorie = (payload) => {
  if (!payload.extraResponse) {
    console.warn('Attenzione! Non risultano presenti le spese accessorie.')
    return []
  }
  const listaSpese = payload.extraResponse.list
  const ids = [...new Set(listaSpese.map(item => item.flagAgenzia))]
  const spese = []
  ids.forEach(flexAgenzia => {
    const list = listaSpese.filter(item => item.flagAgenzia !== undefined && item.flagAgenzia === flexAgenzia)
    if (list.length > 0) {
      spese.push(list)
    }
  })
  const noFlagList = listaSpese.filter(item => item.flagAgenzia === undefined)
  noFlagList.forEach(item => {
    spese.push([item])
  })
  return [...spese]
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/actions/spese.js